import { Stack } from 'react-bootstrap';
import { TripConfig } from './TripConfig';

function About(){
    return <div className="container">
        <div style={{maxWidth:"600px"}}>{TripConfig.aboutText}</div>
        <Stack>
            <div style={{textAlign: "center", width:"600px"}}><b>{TripConfig.aboutImageCaption}</b></div>
        <img style={{width: "600px", height:"auto"}} src={`/img/${TripConfig.aboutImage}`}/>
        </Stack>
      </div>
}

export default About;